// Castintech dashboard — Autonomous Ops view (D18).
// T0 Autonomous Ops Council görünürlük katmanı: self-heal / council / Yılmaz-required /
// failed-recovery / ghost-assignee / stale-agent kuyrukları + son otonom aksiyonlar.
// READ-ONLY (aksiyon butonu YOK — execute governance'da: Council/Board/Yılmaz).
// Endpoint: GET /castintech-api/autonomous-ops/summary (requireAuth).
// ADR: wiki/decisions/2026-06-04-t0-autonomous-ops-council.md
import { apiFetch } from '../api.js';
import { escHtml, ago, $ } from '../utils.js';

interface AOItem {
  id: number;
  title: string;
  message: string;
  actor: string;
  action: string;
  category: string;
  created_at: string;
}
interface AOPayload {
  items: AOItem[];
  summary: { total: number; last24: number; byCategory: Record<string, number>; generated_at: string };
}

const CAT_LABEL: Record<string, string> = {
  'self-heal': 'Self-Heal',
  'council': 'Council',
  'yilmaz-required': 'Yılmaz Gerekli',
  'failed-recovery': 'Başarısız Recovery',
  'ghost-assignee': 'Ghost Assignee',
  'stale-agent': 'Stale Agent',
  'other': 'Diğer',
};

let _payload: AOPayload | null = null;
let _timer: ReturnType<typeof setInterval> | null = null;

export async function loadAutonomousOps(): Promise<void> {
  const sub = $('autonomous-ops-sub');
  if (sub) sub.textContent = 'yükleniyor...';
  try {
    const r = await apiFetch('/castintech-api/autonomous-ops/summary');
    if (!r.ok) throw new Error('HTTP ' + r.status);
    _payload = await r.json();
    renderAutonomousOps();
  } catch (e) {
    if (sub) sub.textContent = 'hata: ' + (e as Error).message;
  }
}

export function renderAutonomousOps(): void {
  const root = $('autonomous-ops-content');
  if (!root) return;
  if (!_payload) { root.innerHTML = '<div class="muted">veri yok</div>'; return; }
  const s = _payload.summary;
  const sub = $('autonomous-ops-sub');
  if (sub) sub.textContent = `${s.total} kayıt · son 24s: ${s.last24} · T0 propose-only (execute governance'da)`;

  const chips = Object.keys(CAT_LABEL)
    .filter((c) => (s.byCategory[c] || 0) > 0)
    .map((c) => `<span class="pill">${escHtml(CAT_LABEL[c])}: <b>${s.byCategory[c]}</b></span>`)
    .join(' ');

  const rows = _payload.items.map((it) => `
    <tr>
      <td><span class="pill">${escHtml(CAT_LABEL[it.category] || it.category)}</span></td>
      <td>${escHtml(it.title)}</td>
      <td class="muted">${escHtml(it.message || '').slice(0, 160)}</td>
      <td class="muted">${escHtml(it.actor || '')}</td>
      <td class="muted">${ago(it.created_at)}</td>
    </tr>`).join('');

  root.innerHTML = `
    <div class="card" style="margin-bottom:12px">
      <div style="display:flex;gap:8px;flex-wrap:wrap">${chips || '<span class="muted">otonom aksiyon yok</span>'}</div>
      <div class="muted" style="margin-top:8px;font-size:12px">
        Bu görünüm <b>read-only</b>. Prosedürler observe-first/draft (aktivasyon §13.6 Yılmaz onayı).
        Self-healing akışı: bulgu → sınıfla → self-heal/council/board. Council tek başına execute etmez.
      </div>
    </div>
    <table class="data-table">
      <thead><tr><th>Kategori</th><th>Başlık</th><th>Mesaj</th><th>Aktör</th><th>Zaman</th></tr></thead>
      <tbody>${rows || '<tr><td colspan="5" class="muted">kayıt yok</td></tr>'}</tbody>
    </table>`;
}

export function startAutonomousOpsTimer(): void {
  stopAutonomousOpsTimer();
  _timer = setInterval(() => void loadAutonomousOps(), 30_000);
}
export function stopAutonomousOpsTimer(): void {
  if (_timer) { clearInterval(_timer); _timer = null; }
}
